export default "/assets/website/images/cart.svg?af57322a9e203148a6f79318acbb7cda";